export const pixelRevenue = 0;

export type PixelRevenue = typeof pixelRevenue;
